"use client";
import {
  useFormField
} from "../__chunks/ZF6AA2GH.js";
import {
  useFormContext
} from "../__chunks/DPO6VSJT.js";
import {
  useRadio
} from "../__chunks/IO2C6XLJ.js";
import "../__chunks/ZQKNDRGB.js";
import "../__chunks/CQCRBYV6.js";
import "../__chunks/XVQ3TNPZ.js";
import "../__chunks/BY5KOAGY.js";
import "../__chunks/6QXBPV75.js";
import "../__chunks/X3ATWMYX.js";
import "../__chunks/KSMDNUGB.js";
import "../__chunks/HJIEYVEO.js";
import "../__chunks/SHA3WOPI.js";
import {
  createElement,
  createHook,
  createMemoComponent
} from "../__chunks/LFJDOMBA.js";
import "../__chunks/2ID5JPOO.js";
import {
  useEvent
} from "../__chunks/6WEF4WY5.js";
import "../__chunks/OZVWZODE.js";
import {
  __objRest,
  __spreadProps,
  __spreadValues
} from "../__chunks/2SMRF6AD.js";

// src/form/form-radio.ts
import { invariant } from "@ariakit/core/utils/misc";
var useFormRadio = createHook(
  (_a) => {
    var _b = _a, { store, name: nameProp, value } = _b, props = __objRest(_b, ["store", "name", "value"]);
    const context = useFormContext();
    store = store || context;
    invariant(
      store,
      process.env.NODE_ENV !== "production" && "FormRadio must be wrapped in a Form component."
    );
    const name = `${nameProp}`;
    const onChangeProp = props.onChange;
    const onChange = useEvent((event) => {
      onChangeProp == null ? void 0 : onChangeProp(event);
      if (event.defaultPrevented)
        return;
      store == null ? void 0 : store.setValue(name, value);
    });
    const checkedProp = props.checked;
    const checked = store.useState(
      () => checkedProp != null ? checkedProp : (store == null ? void 0 : store.getValue(name)) === value
    );
    props = __spreadProps(__spreadValues({}, props), {
      checked,
      onChange
    });
    props = useRadio(__spreadValues({ value }, props));
    props = useFormField(__spreadValues({
      store,
      name,
      "aria-labelledby": void 0
    }, props));
    return props;
  }
);
var FormRadio = createMemoComponent((props) => {
  const htmlProps = useFormRadio(props);
  return createElement("input", htmlProps);
});
if (process.env.NODE_ENV !== "production") {
  FormRadio.displayName = "FormRadio";
}
export {
  FormRadio,
  useFormRadio
};
